import { render, staticRenderFns } from "./PostPlantTable.vue?vue&type=template&id=5d6bc75a&scoped=true&"
import script from "./PostPlantTable.vue?vue&type=script&lang=js&"
export * from "./PostPlantTable.vue?vue&type=script&lang=js&"
import style0 from "./PostPlantTable.vue?vue&type=style&index=0&id=5d6bc75a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6bc75a",
  null
  
)

export default component.exports